import { GRADES as AVATAR_GRADES } from '@amplify/avatar-builder'

import { GRADES } from 'app/types/grades.types'

export const avatarCompatibleGradesMap: Record<GRADES, AVATAR_GRADES> = {
  [GRADES.KINDERGARTEN]: AVATAR_GRADES.K,
  [GRADES.FIRST_GRADE]: AVATAR_GRADES.FIRST,
  [GRADES.SECOND_GRADE]: AVATAR_GRADES.SECOND,
  [GRADES.THIRD_GRADE]: AVATAR_GRADES.THIRD,
  [GRADES.FOURTH_GRADE]: AVATAR_GRADES.FOURTH,
  [GRADES.FIFTH_GRADE]: AVATAR_GRADES.FIFTH,
}
